import React, { useState, useEffect } from 'react';
import { Input } from 'components/shared/FormComponent';
import { Empty, message, Popconfirm, Table, Tooltip } from 'components/shared/AntComponent';
import SearchIcon from 'assets/img/search.svg';
import { DeleteFilled } from 'components/shared/AntIcons';
import { EditIcon } from 'assets/img/custom-icons';
import { Button } from 'components/shared/ButtonComponent';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/table.scss';
import dayjs from 'dayjs';
import { getAllNotificationCenter, removeNotificationCenter } from 'services/actions/notificationCenterAction';

const AdminNotificationCenter: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userRole = sessionStorage.getItem('role');
    const { userProfileInfo } = useSelector((state: any) => state.auth);
    const { notifyCenterInfo, loading, error2, success2 } = useSelector((state: any) => state.notifyCenter);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isStatus, setIsStatus] = useState('Active');
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    const [searchTableVal, setsearchTableval] = useState('');
    const data = !loading ? notifyCenterInfo?.data : [];
    const totalPage = !loading ? notifyCenterInfo?.data?.length : 0;
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success2 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error2 : false;


    const customLocale = {
        emptyText: <Empty className="p-2" description="No Notification available" />,
    };

    const columns: any['columns'] = [
        {
            title: 'S.no',
            dataIndex: 'sno',
            key: 'sno',
            render: (id: number, record: any, index: number) => {
                if (pageIndex === 1) {
                    return index + 1;
                } else {
                    return (pageIndex - 1) * pageSize + (index + 1);
                }
            },
        },
        {
            title: 'Notification Title',
            dataIndex: 'title',
            key: 'title',
            sorter: true,
            // render: (_: any, record: any) => (
            //     <div>{record?.encrypt_templateNumber || "--"}</div>
            // )
        },
        // {
        //     title: 'Notification Type',
        //     dataIndex: 'notification_type',
        //     key: 'notification_type',


        // },
        {
            title: 'Start Date',
            dataIndex: 'start_date',
            key: 'start_date',
            render: (_: any, record: any) => {
                return notifyCenterInfo ? (record?.start_date ? dayjs(record?.start_date)?.format('MM/DD/YYYY') : "--") : null;
            },
        },
        {
            title: 'End Date',
            dataIndex: 'end_date',
            key: 'end_date',
            render: (_: any, record: any) => {
                return notifyCenterInfo ? (record?.end_date ? dayjs(record?.end_date)?.format('MM/DD/YYYY') : "--") : null;
            },
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',

        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'action',
            align: 'center',
            render: (status: any) => {
                const val = status?.toLowerCase();
                if (status === 'Active') {
                    return <div className='status-section mx-auto'><Button className="success-btn fw-bold text-center mx-auto px-2">{status}</Button></div>;
                } else {
                    return <div className='status-section mx-auto'><Button className="danger-btn text-center mx-auto px-2 text-capitalize">{val}</Button></div>;
                }
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            className: 'action-column',
            // align:'center',
            render: (_id: any, record: any) => {
                return (
                    <div
                        className="p-2 text-center d-flex align-items-center justify-content-center"
                        onClick={(event) => {
                            event.stopPropagation();
                        }}
                    >
                        <Tooltip title="Edit">
                            <div className=" pb-0 pe-1 mb-auto text-end edit-icon text-success edit-card col-auto pointer" onClick={() => handleEdit(record)}>
                                <EditIcon />
                            </div>
                        </Tooltip>
                        <Tooltip title="Delete" className="mt-0">
                            <Popconfirm
                                placement="topLeft"
                                title="Are you sure to delete this notification?"
                                description="Delete the notification"
                                onConfirm={() => {
                                    confirmDelete(record?.id);
                                    // setShowSuccessmsg1(true);
                                    // setShowErrormsg1(true);
                                }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Tooltip title="Delete" className="mt-0">
                                    <DeleteFilled className="fs-18 text-danger" />
                                </Tooltip>
                            </Popconfirm>
                            {/* <DeleteFilled className="fs-18 text-danger" onClick={() => handleOpenDelModal(record)} /> */}
                        </Tooltip>
                        {/* {(userRole === 'researcher' || userProfileInfo?.data?.sub_roll === 'researcher') ? (
                                <DeleteFilled className="text-secondary" />
                            ) : (
                                <Popconfirm
                                    placement="topLeft"
                                    title="Are you sure to delete this patient?"
                                    description="Delete the patient"
                                    onConfirm={() => {
                                        confirmDelete('False', record.id);
                                        setShowSuccessmsg1(true);
                                        setShowErrormsg1(true);
                                    }}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Tooltip title="Delete" className="mt-0">
                                        <DeleteFilled className="fs-18 text-danger" />
                                    </Tooltip>
                                </Popconfirm>
                            )} */}
                    </div>
                );
            },
        },
    ];
    const tableChange = (pagination: any, ...sorted: any) => {
        let sort = '',
            sortfield = '';
        if (sorted[1].order === 'ascend') {
            sort = 'asc';
        } else if (sorted[1].order === 'descend') {
            sort = 'desc';
        } else sort = '';
        setPageIndex(pagination.current);
        if (sort == '') {
            sortfield = '';
            setSortField('');
        } else {
            setSortField(sorted[1].field);
            sortfield = sorted[1].field;
        }
        setSortOrder(sort);
        setPageSize(pagination.pageSize);
        // getAccount(searchTableVal, pagination.current, pagination.pageSize, sortfield, sort, isStatus);
    };
    const handleEdit = (val: any) => {
        navigate('/add-notification', { state: { id: val?.id, rowData: val } })
    }
    const handleSearch = (e: any) => {
        if (e.key === 'Enter') {
            setsearchTableval(e.target.value)
            setPageIndex(1);
            // getAccount(e.target.value, 1, pageSize, '', '', isStatus);
        }
    };

    const resetSearch = (e: any) => {
        if (e.key === 'Backspace' && !e.target.value) {
            setsearchTableval('');
            setPageIndex(1);
            // getAccount(e.target.value, 1, pageSize, '', '', isStatus);
        }
    };

    const searchbyBtn = () => {
        setPageIndex(1);
        // getAccount(searchTableVal, 1, pageSize, '', '', isStatus);
    };
    const confirmDelete = (val: any) => {
        dispatch(removeNotificationCenter(val) as any);
        setShowErrormsg(true);
        setShowSuccessmsg(true);
    }

    const handleShowAddScreen = () => {
        // setShowAdd(true);
        navigate('/add-notification', { state: { id: 0, rowData: null } });
    }

    const getNotificationsAll = () => {
        dispatch(getAllNotificationCenter({}) as any);
    }

    useEffect(() => {
        getNotificationsAll();
    }, []);
    useEffect(() => {
        if (successmsg) {
            message.success("Notification deleted successfully");
            setShowSuccessmsg(false);
            getNotificationsAll();

        }
        if (errormsg) {
            if (error2?.data) {
                message.error(error2?.data);
            } else {
                message.error("Notification couldn't be created");
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    return (
        <div className='p-3'>
            <div className="d-flex grid-title-card">
                <h5 className="my-auto ">Notification Center</h5>

                <div className="ms-auto d-flex title-btn">
                    {/* <Radio.Group defaultValue={isStatus} buttonStyle="solid" className="col pe-0 me-2 text-end" onChange={handleStatusChange}>
                        <Radio.Button className="active" value="Active">
                            Active
                        </Radio.Button>
                        <Radio.Button className="inactive px-2" value="InActive">
                            Inactive
                        </Radio.Button>
                    </Radio.Group> */}
                    <Input
                        prefix={<img src={SearchIcon} height="14px" onClick={searchbyBtn} />}
                        onKeyDown={(e) => handleSearch(e)}
                        value={searchTableVal}
                        onChange={(e) => setsearchTableval(e.target.value)}
                        onKeyUp={(e) => resetSearch(e)}
                        className="search-input me-2 col px-2 rounded fs-14"
                        placeholder="Search"
                    />
                    {userRole == 'researcher' || userProfileInfo?.data?.sub_roll === 'researcher' ? '' : <Tooltip title="Add new notification">
                        <Button type="primary" onClick={handleShowAddScreen} className="add-btn">
                            Add
                        </Button>
                    </Tooltip>}
                </div>

            </div>
            <div className="my-2">
                <Table
                    rowKey="id"
                    className="pointer border"
                    columns={columns}
                    dataSource={loading ? [] : data}
                    loading={loading}
                    onChange={tableChange}
                    scroll={{ x: 'calc(230px + 50%)' }}
                    locale={customLocale}
                    // onRow={(record: any) => {
                    //     return {
                    //         onClick: () => {
                    //             navigateNextScreen(record?.id);
                    //         },
                    //     };
                    // }}
                    pagination={{
                        current: pageIndex,
                        pageSize: pageSize,
                        total: totalPage,
                    }}
                />
            </div>

        </div>
    )
}

export default AdminNotificationCenter;